import { StyleSheet, Text, View } from 'react-native';
import { Button } from '../../crop-circle/Button';
import { colors, spacing, tokens } from '../../crop-circle/tokens';
import { OpenEndedResponse } from './types';
import { Colors } from '../../../themes/colors';

export type StatusExecutionComponentProps = {
  statuses: string[];
  value: string;
  onChange: (status: string) => void;
  disabled?: boolean;
};

export const StatusExecutionComponent = (
  props: StatusExecutionComponentProps
) => {
  const filteredStatuses = props.statuses.filter(
    (status: string | number) => status !== OpenEndedResponse
  );

  return (
    <View style={styles.buttonsContainer}>
      {filteredStatuses.map((status: string | number) => {
        const isSelected = status === props.value;

        return (
          <Button
            key={status}
            onPress={() => props.onChange(String(status))}
            disabled={props.disabled}
            state={isSelected ? 'active' : 'default'}
            variant="rectangular"
            size="large"
          >
            <Text
              style={[
                styles.buttonLabel,
                isSelected && styles.currentButtonLabel,
              ]}
            >
              {status}
            </Text>
          </Button>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  buttonsContainer: {
    flexDirection: 'column',
    gap: spacing.sm,
  },
  buttonLabel: {
    ...tokens.typography.body.medium,
    color: Colors.role.textPrimary,
  },
  // Sits on the Button's active fill (`surfaceInverse`), so it pairs with it.
  currentButtonLabel: {
    color: Colors.role.textOnInverse,
  },
});
